module.exports = __webpack_public_path__ + "static/media/check.e53ca545.svg";